<template>
    <div class="play">
        <div id="mse" class="play"></div>
    </div>
</template>

<script>
import Player from 'xgplayer';
import HlsPlayer from 'xgplayer-hls';
import qs from 'qs';
export default {
    name: 'Xplay',
    mounted() {
        this.initPlay(); 
    },
    methods: {
        // 获取url参数
        getUrlParame() {
            let url = window.location.search;
            let index = url.indexOf('?')
            if (index === -1) return {};
            let params = url.slice(index + 1);
            return qs.parse(params);
        },
        initPlay() {
            //  let url = "https://thm3u8.com/20250924/7BvzZwXj/index.m3u8";
            let url = this.getUrlParame()['url'] || "";
            if (url === "") {
                return;
            }
            let HlsPlayerDome = new Player({
                id: "mse",
                "url": url,
                "playsinline": true,
                "playbackRate": [
                    0.75,
                    1,
                    1.5,
                    2,
                    3
                ],
                "rotate": {
                    "clockwise": false,
                    "innerRotate": true
                },
                "download": false,
                "preloadTime": 120,
                "pip": true,
                "width": "100%",
                "height": "100%",
                "autoplay": true,
                plugins: [HlsPlayer]

            });
        }
    }
}
</script>

<style>
@import url('/node_modules/xgplayer/dist/index.min.css');

html,
body {
    width: 100%;
    background-color: #090909;
    height: 100%;
    margin: 0;
    padding: 0;
}

.play {
    width: 100%;
    /* background-color: red; */
    height: 100%;
}
</style>
